<sbnb-signup-wizard-template>
  <ng-container left-side>
    <h1 class="mb-8 text-2xl md:text-3xl">Where are your properties listed?</h1>

    <p class="mb-6">We support more channels than listed below, but select those that you are currently active with.</p>

    <div *ngFor="let channel of channels">
      <mat-checkbox (change)="toggleChannel(channel.key)" [checked]="channel.enabled">{{ channel.label }}</mat-checkbox>
    </div>

    <mat-checkbox (change)="toggleNotListed()" [checked]="notListedChecked">I'm not listed yet!</mat-checkbox>

    <sbnb-button
      class="block mt-8"
      [fullWidth]="true"
      [disabled]="!notListedChecked && !atLeastOneChannelEnabled"
      [loading]="isSaving"
      (clicked)="onContinue()">
      Continue
    </sbnb-button>

    <sbnb-button
      *ngIf="propertyCount > 0"
      class="block mt-4"
      type="text"
      labelColor="#ED3C6A"
      [fullWidth]="true"
      (clicked)="onBookDemo()">
      Book a demo call
    </sbnb-button>
  </ng-container>

  <sbnb-channels-image
    right-side
    [channels]="channels"
    [avatar]="signupUserService.user$.value?.avatar"></sbnb-channels-image>
</sbnb-signup-wizard-template>
